<template>
  <v-footer dark padless>
    <v-card flat tile class="secondary white--text text-center">
      <v-card-text class="white--text pt-6">
        卫旻科技 —— 开源源码 · 定制开发 · 网站搭建 · 线上服务，一站式网络科技服务伙伴。
      </v-card-text>
      <v-card-text class="white--text pt-0">
        邮箱：286350288@qq.com
      </v-card-text>

      <v-divider></v-divider>

      <v-card-text class="white--text pt-4 pb-0">
        <a
          href="https://beian.miit.gov.cn/"
          target="_blank"
          rel="noopener"
          class="white--text"
        >皖ICP备2026030023号-2</a>
      </v-card-text>

      <v-card-text class="white--text">
        {{ new Date().getFullYear() }} — <strong>卫旻科技 WEIMIN TECH</strong>
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<style scoped>
.v-card {
  width: 100%;
}
</style>

<script>
export default {
  data: () => ({}),
};
</script>
